import endpoints, { formatEndpoint } from '../endpoints';
import { RestManagerWithoutBaseUrl } from '../RestManager';

class powertrainActions {
    getPowertrains(params) {
        const endpoint = formatEndpoint(endpoints.powertrainV2.getPowertrains);
        return RestManagerWithoutBaseUrl.post(endpoint, params);
    }

    getAvailableAssets(params) {
        const endpoint = formatEndpoint(endpoints.powertrainV2.getAvailableAssets);
        return RestManagerWithoutBaseUrl.post(endpoint, params);
    }

    deletePowertrain(id) {
        const endpoint = formatEndpoint(endpoints.powertrainV2.deletePowertrain, { id });
        return RestManagerWithoutBaseUrl.delete(endpoint);
    }

    addPowertrain(powertrain) {
        const endpoint = formatEndpoint(endpoints.powertrainV2.addPowertrain);
        return RestManagerWithoutBaseUrl.post(endpoint, powertrain);
    }

    updatePowertrain(powertrain) {
        const endpoint = formatEndpoint(endpoints.powertrainV2.updatePowertrain);
        return RestManagerWithoutBaseUrl.post(endpoint, powertrain);
    }

    getAssetDetails(params) {
        const endpoint = formatEndpoint(endpoints.powertrainV2.getAssetDetails);
        return RestManagerWithoutBaseUrl.post(endpoint, params);
    }

    getAssetSubTypes(typeConfigId) {
        const endpoint = formatEndpoint(endpoints.powertrainV2.getAssetSubTypes, { typeConfigId });
        return RestManagerWithoutBaseUrl.get(endpoint);
    }

    getHierarchyData(organizationId, siteIds = null) {
        const endpoint = formatEndpoint(endpoints.powertrainV2.getHierarchyData, { organizationId });
        return RestManagerWithoutBaseUrl.post(endpoint, { organizationId, siteIds });
    }

    getHierarchyDataForSite(organizationId, siteIds) {
        const endpoint = formatEndpoint(endpoints.powertrainV2.getHierarchyData, { organizationId });
        return RestManagerWithoutBaseUrl.post(endpoint, {
            organizationId,
            siteIds: Array.isArray(siteIds) ? siteIds : [siteIds],
            includeLocationsOnly: true
        });
    }

    updateHierarchyData(hierarchyData, siteId) {
        const endpoint = formatEndpoint(endpoints.powertrainV2.updateHierarchyData, { siteId });
        return RestManagerWithoutBaseUrl.post(endpoint, hierarchyData);
    }

    convertToLocation(powertrainId, rowVersion) {
        const endpoint = formatEndpoint(endpoints.powertrainV2.convertToLocation, { id: powertrainId });
        return RestManagerWithoutBaseUrl.post(endpoint, { powertrainId, rowVersion });
    }
}

export default new powertrainActions();
